export default function selectValue(state, key) {
  return state.ui[key]
}
